import React from 'react';
import { Badge } from '@chakra-ui/react';
import PropTypes from 'prop-types';

// RAT-1860: formats the backend-computed status; anything not 'Complete' reads
// as Incomplete. Never re-derives which legal fields are required.
const LegalInfoBadge = ({ status }) => {
  const isComplete = status === 'Complete';

  return (
    <Badge
      colorScheme={isComplete ? 'green' : 'red'}
      fontSize="xs"
      fontWeight="600"
      textTransform="none"
      borderRadius="full"
      px="10px"
      py="2px"
    >
      {isComplete ? 'Complete' : 'Incomplete'}
    </Badge>
  );
};

LegalInfoBadge.propTypes = {
  status: PropTypes.string,
};

export default LegalInfoBadge;
